import React from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';
import { formatRut } from '../../../utils/rut';

const InputRut = ({ value, onChange, ...props }) => {
  const preHandleChange = (e) => {
    onChange?.(formatRut(e.target.value));
  };

  return <Input className="input-rut" onChange={preHandleChange} value={value} {...props} />;
};

InputRut.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

InputRut.defaultProps = {
  value: '',
  onChange: undefined,
};

export default InputRut;
